export default __webpack_public_path__ + "static/media/Podcasts.7911dd64.svg";